<template>
  <div class="zones-and-products">
    <!-- Mobile Filter Toggle Button -->
    <div class="mobile-filter-toggle" @click="toggleMobileFilters">
      <div class="filter-toggle-content">
        <img
          class="filter-icon"
          alt="Filter icon"
          src="/img/majesticons-list-box.svg"
        />
        <span class="filter-toggle-text">Filtres</span>
        <div class="active-filters-count" v-if="activeFiltersCount > 0">
          {{ activeFiltersCount }}
        </div>
        <div class="toggle-arrow" :class="{ 'rotated': showMobileFilters }">
          <img src="/img/chevron-up-7.svg" alt="Toggle" />
        </div>
      </div>
    </div>

    <!-- Desktop Layout (always visible) -->
    <div class="desktop-filters">
      <div class="div">
        <div class="lighttitle">
          <img
            class="healthicons"
            alt="Heroicons solid"
            src="/img/heroicons-solid-location-marker.svg"
          />
          <div class="lighttitle-text">Zones géographiques</div>
        </div>
        <div class="categories">
          <ChipsCategory
            v-for="zone in zones" 
            :key="zone"
            class="chips-category-instance"
            :property1="selectedZone === zone ? 'variant-2' : 'default'"
            :tablerCheck="selectedZone === zone ? '/img/tabler-check-2.svg' : ''"
            :text="zone"
            @click="() => { console.log('ChipsCategory clicked in template with zone:', zone); selectZone(zone); }"
          />
        </div>
      </div>
      <div class="div">
        <div class="lighttitle">
          <div class="healthicons">
            <img class="group" alt="Group" src="/img/group.png" />
          </div>
          <div class="lighttitle-text">Produits</div>
        </div>
        <div class="categories">
          <ChipsCategory
            v-for="category in productCategories"
            :key="category"
            class="chips-category-instance"
            :property1="selectedProductCategory === category ? 'variant-2' : 'default'"
            :tablerCheck="selectedProductCategory === category ? '/img/tabler-check-2.svg' : ''"
            :text="category"
            @click="() => selectProductCategory(category)"
          />
        </div>
      </div>
    </div>

    <!-- Mobile Collapsible Filters -->
    <div class="mobile-filters" :class="{ 'expanded': showMobileFilters }">
      <div class="mobile-filter-section">
        <div class="mobile-section-title">
          <img
            class="mobile-section-icon"
            alt="Location"
            src="/img/heroicons-solid-location-marker.svg"
          />
          <span>Zones</span>
        </div>
        <div class="mobile-categories">
          <ChipsCategory
            v-for="zone in zones" 
            :key="`mobile-zone-${zone}`"
            class="chips-category-mobile"
            :property1="selectedZone === zone ? 'variant-2' : 'default'"
            :tablerCheck="selectedZone === zone ? '/img/tabler-check-2.svg' : ''"
            :text="zone"
            @click="() => selectZone(zone)"
          />
        </div>
      </div>
      
      <div class="mobile-filter-section">
        <div class="mobile-section-title">
          <img class="mobile-section-icon" alt="Products" src="/img/group.png" />
          <span>Produits</span>
        </div>
        <div class="mobile-categories">
          <ChipsCategory
            v-for="category in productCategories"
            :key="`mobile-category-${category}`"
            class="chips-category-mobile"
            :property1="selectedProductCategory === category ? 'variant-2' : 'default'"
            :tablerCheck="selectedProductCategory === category ? '/img/tabler-check-2.svg' : ''"
            :text="category"
            @click="() => selectProductCategory(category)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChipsCategory from "../../../components/ChipsCategory.vue";
import membresData from "../../../membres.json";
import membresDataWithLogo from "../../../member24v.json";
import productsData from "../../../products-zones.json";
import productCategoriesData from "../../../product-categories.json";

export default {
  name: "ZonesAndProducts",
  components: {
    ChipsCategory
  },
  data() {
    return {
      selectedZone: "Tout", // Internal state for highlighting the active chip
      selectedProductCategory: "Tout",
      showMobileFilters: false, // For mobile collapsible filters
    };
  },
  computed: {
    zones() {
      const uniqueZones = new Set();
      
      // Extract zones from member24v.json (the preferred zone convention)
      membresDataWithLogo.forEach(member => {
        const zoneField = member["Zone"] || member["Zone "]; // Handle potential key variations
        if (zoneField && typeof zoneField === 'string') {
          const cleanZone = zoneField.trim();
          if (cleanZone) { // Add if not empty after trimming
            uniqueZones.add(cleanZone);
          }
        }
      });
      
      // Sort zones alphabetically and prepend "Tout"
      const sortedZones = Array.from(uniqueZones).sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));
      return ["Tout", ...sortedZones];
    },
    productCategories() {
      return ["Tout", ...Object.keys(productCategoriesData)];
    },
    activeFiltersCount() {
      let count = 0;
      if (this.selectedZone !== "Tout") count++;
      if (this.selectedProductCategory !== "Tout") count++;
      return count;
    }
  },
  methods: {
    selectZone(zone) {
      console.log("ZonesAndProducts - selectZone method called with:", zone); // Log inside the method
      this.selectedZone = zone; // Update internal state for UI
      const emittedValue = zone === "Tout" ? null : zone;
      console.log("ZonesAndProducts - Emitting zone-selected:", emittedValue); // Log the emitted value
      this.$emit('zone-selected', emittedValue);
    },
    selectProductCategory(category) {
      this.selectedProductCategory = category;
      const emittedValue = category === "Tout" ? null : category;
      this.$emit('category-selected', emittedValue);
    },
    toggleMobileFilters() {
      this.showMobileFilters = !this.showMobileFilters;
    }
  }
};
</script>

<style>

.zones-and-products .chips-category-instance {
  cursor: pointer;
  transition: all 0.2s ease;
}

.zones-and-products .chips-category-instance:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* For non-selected chips, add hover background effect */
.zones-and-products .chips-category-instance[property1="default"]:hover {
  background-color: rgba(22, 53, 24, 0.05);
}


.zones-and-products {
  /* align-items: center; */
  display: flex;
  gap: 36px;
  margin: 0px 8vw;
  /* left: 267px; */
  /* position: absolute; */
  /* top: 225px; */
  /* width: 1248px; */
}



/* Add a selected state style */
.zones-and-products .chips-categories.selected {
  background-color: #163518;
}

.zones-and-products .chips-categories.selected .chips-text {
  color: white;
}

/* Add hover effect */
.zones-and-products .chips-categories {
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.zones-and-products .chips-categories:hover {
  background-color: rgba(22, 53, 24, 0.1);
}

.zones-and-products .div {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-grow: 1;
  gap: 8px;
  overflow: hidden;
  /* position: relative; */
}

.zones-and-products .lighttitle {
  align-items: flex-start;
  border-radius: 100px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  padding: 4px 12px;
  /* position: relative; */
}

.zones-and-products .healthicons {
  height: 24px;
  /* position: relative; */
  width: 24px;
}

.zones-and-products .lighttitle-text {
  color: #000000;
  font-family: "Mona-Sans-Medium", Helvetica;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: -0.50px;
  /* position: relative; */
  white-space: nowrap;
  width: fit-content;
}

.zones-and-products .categories {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 6px 6px;
  /* overflow-x: scroll; */
  /* position: relative; */
  width: 100%;
}

.zones-and-products .categories::-webkit-scrollbar {
  display: none;
  width: 0;
}

.zones-and-products .chips-categories {
  align-items: center;
  border: 0.5px solid;
  border-color: #163518;
  border-radius: 100px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  justify-content: center;
  padding: 4px 12px;
  /* position: relative; */
}

.zones-and-products .chips-text {
  color: #163518;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 15px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 24px;
  /* margin-top: -0.50px; */
  /* position: relative; */
  white-space: nowrap;
  width: fit-content;
}

.zones-and-products .group {
  height: 18px;
  left: 3px;
  /* position: absolute; */
  top: 3px;
  width: 18px;
}

.zones-and-products .chips-category-instance {
  flex: 0 0 auto !important;
}
.zones-and-products .chips-category-instance {
  flex: 0 0 auto !important;
}

/* Mobile Filter Toggle Button - Hidden on desktop */
.mobile-filter-toggle {
  display: none;
}

/* Desktop Filters - Hidden on mobile */
.desktop-filters {
  display: flex;
  gap: 36px;
}

/* Mobile Filters - Hidden by default */
.mobile-filters {
  display: none;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, padding 0.3s ease-in-out;
  background: rgba(230, 227, 181, 0.1);
  border-radius: 16px;
  margin-top: 12px;
}

.mobile-filters.expanded {
  max-height: 800px;
  padding: 16px;
}

.mobile-filter-section {
  margin-bottom: 20px;
}

.mobile-filter-section:last-child {
  margin-bottom: 0;
}

.mobile-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #3b723e;
  font-family: "Mona-Sans-Medium", Helvetica;
  font-size: 16px;
  font-weight: 500;
}

.mobile-section-icon {
  width: 20px;
  height: 20px;
}

.mobile-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chips-category-mobile {
  flex: 0 0 auto;
}

.filter-toggle-content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #3b723e;
  border-radius: 24px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(59, 114, 62, 0.2);
}

.filter-toggle-content:hover {
  background: #2d5a31;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 114, 62, 0.3);
}

.filter-icon {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}

.filter-toggle-text {
  font-family: "Mona-Sans-SemiBold", Helvetica;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
}

.active-filters-count {
  background: #ffffff;
  color: #3b723e;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  min-width: 24px;
}

.toggle-arrow {
  width: 16px;
  height: 16px;
  transition: transform 0.3s ease;
}

.toggle-arrow.rotated {
  transform: rotate(180deg);
}

.toggle-arrow img {
  width: 100%;
  height: 100%;
  filter: brightness(0) invert(1);
}

@media (max-width: 773px) {
  .zones-and-products {
    display: block;
    gap: 0;
    margin: 0px 7vw;
  }
  
  /* Hide desktop filters on mobile */
  .desktop-filters {
    display: none;
  }
  
  /* Show mobile filter toggle */
  .mobile-filter-toggle {
    display: block;
    margin-bottom: 8px;
  }
  
  /* Show mobile filters container */
  .mobile-filters {
    display: block;
  }
}

@media (max-width: 480px) {
  .zones-and-products {
    margin: 0px 4vw;
  }
  
  .filter-toggle-content {
    padding: 10px 14px;
  }
  
  .filter-toggle-text {
    font-size: 15px;
  }
  
  .mobile-section-title {
    font-size: 15px;
  }
  
  .mobile-categories {
    gap: 6px;
  }
}
</style>